import { useCallback, useState } from 'react';
import { useInputAction } from '~/rage';
import { InputAction } from '~/shared';

const useShopCategoryControls = (
	initialIndex: number | null,
	handleSelect: (index: number) => void,
	disabled?: boolean,
) => {
	const [activeCategoryIndex, setActiveCategoryIndex] = useState<number | null>(
		initialIndex,
	);
	const [maxCategoryIndex, setMaxCategoryIndex] = useState(0);

	const handleMenuNavigation = useCallback(
		(offset: number) => {
			if (disabled) return;

			if (activeCategoryIndex === null || activeCategoryIndex === -1) {
				setActiveCategoryIndex(0);
				return;
			}

			const newIndex = activeCategoryIndex + offset;

			if (newIndex >= 0 && newIndex < maxCategoryIndex) {
				setActiveCategoryIndex(newIndex);
			}
		},
		[activeCategoryIndex, maxCategoryIndex, disabled],
	);

	useInputAction(InputAction.CommonMenuAccept, () => {
		if (disabled) return;

		if (activeCategoryIndex === null || activeCategoryIndex === -1) {
			setActiveCategoryIndex(0);
			return;
		}

		if (handleSelect) {
			handleSelect(activeCategoryIndex);
		}
	});

	useInputAction(InputAction.CommonMenuNavUp, () => handleMenuNavigation(-3));
	useInputAction(InputAction.CommonMenuNavDown, () => handleMenuNavigation(3));
	useInputAction(InputAction.CommonMenuNavLeft, () => handleMenuNavigation(-1));
	useInputAction(InputAction.CommonMenuNavRight, () => handleMenuNavigation(1));

	return {
		activeCategoryIndex,
		setActiveCategoryIndex,
		setMaxCategoryIndex,
	};
};

export { useShopCategoryControls };
